
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/love-stories",
      function () {
        return require("private-next-pages/love-stories.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/love-stories"])
      });
    }
  